import environment from "src/utils/environment";
import BrowserEventEmitter from "events";

export default environment.isBrowser ? BrowserEventEmitter : require("events");
